import types from 'components/addresses/actions'

export default madeSuggestion => ({
  type: types.SUGGESTION_SELECTED,
  madeSuggestion,
})
